import { styled } from "styled-components";

/** 조건 검색 섹션 카드 컨테이너. */
export const FilterPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 20px;
  background: #ffffff;
  border-radius: 4px;
  font-family: "Noto Sans KR";
`;

/** 라벨 + 입력들이 한 줄로 놓이는 행. */
export const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

/** 행 왼쪽의 고정폭 라벨(행 간 좌측 정렬을 맞춘다). */
export const FilterLabel = styled.span`
  flex-shrink: 0;
  min-width: 80px;
  white-space: nowrap;
  color: var(--text-black, #111);
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
`;

/** 입력 영역과 검색/초기화 버튼을 가르는 구분선. */
export const FilterDivider = styled.hr`
  width: 100%;
  margin: 4px 0;
  border: none;
  border-top: 1px solid var(--admin-gray-stroke, #e8e8e8);
`;
